// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dropdown-obsolescence-filter.dropdown-toggle::after {
    display: inline-block !important;
}`, "",{"version":3,"sources":["webpack://./src/features/StudyDetails/components/ObsolescenceFilter/ObsolescenceFilter.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC","sourcesContent":["#dropdown-obsolescence-filter.dropdown-toggle::after {\n    display: inline-block !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
